import Vue from 'vue'
import Report from './report.vue'
import '@/scripts/axios.js'
import App from "@/App.vue";
import store from "@/store";
import mixin from "@/mixin/mixin";
Vue.mixin(mixin);
import VueRouter from "vue-router";

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/report",
            name: "report",
            components: {
                main: Report,
            },
            meta: {
                title: "چاپ",
            },
        },
    ]
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        if (localStorage.getItem("token")) {
            this.$store.dispatch("loadLocalUserData");
        }
    },
}).$mount('#app')